import { SAMSUNG_BEST_BUY_COUPON_SWEETENER_KEY } from "~/constants/samsungOffer";
import type { Product, Sweetener } from "~/types/products";

/**
 * Returns the mapped sweetener when FRAPI sent a COUPON line and OL attached it under
 * the `samsung-best-buy-coupon` key.
 */
export function getSamsungBestBuySweetener(sweeteners: Product["sweeteners"] | undefined): Sweetener | undefined {
  if (!sweeteners) {
    return undefined;
  }
  return sweeteners[SAMSUNG_BEST_BUY_COUPON_SWEETENER_KEY];
}
